// extracted by mini-css-extract-plugin
export default {"fieldset":"CallRecordFilter_fieldset__Ejjlg","legendTitle":"CallRecordFilter_legendTitle__hksaM"};